<template>
  <span> </span>
</template>

<script>
import shuffleInplace from "fisher-yates/inplace";
import { sendNomination, createSelfEvaluation, sendSurvey, sendComment, sendRPSAnswer, sendActionPlanVote } from "../services/APIService";

const sample = require("lodash.sample");

export default {
  data: function () {
    return {
      selfEvaluationStart: 0,
      selfEvaluationStop: 0,
      gameStart: 0,
      gameStop: 0
    };
  },
  mounted() {
    this.clearIntervals();

    if (!this.$store.getters.areThereRobotPlayers || !this.$store.getters.getIsFacilitator || this.$store.state.main.playerIsObserver) {
      return;
    }

    if (this.$store.state.main.game.actionPlanActivated) {
      // In reporting only robot we need is voting
      this.startVotingTimeout();
      return;
    }


    if (this.$store.getters.getIsClassic) {
      this.startSelfEvaluationTimeout();

      if (this.$router.currentRoute.name === "Game") {
        this.startGameTimeout();
      }

      if (this.$router.currentRoute.name === "Game" && this.$store.state.main.game.enableComments) {
        this.startCommentTimeout();
      }
    } else {
      // RPS
      this.startRPSTimeout();
    }
  },
  destroyed() {
    this.clearIntervals();
  },
  computed: {
    timeOut() {
      return this.$store.getters.getRobotPlayers.length > 7 ? 500 : 1000;
    }
  },
  methods: {
    startSelfEvaluationTimeout() {
      const id = setInterval(async () => {
        this.selfEvaluationRobot();
      }, 1000);

      this.$store.commit({
        type: "setSelfEvaluationTimer",
        selfEvaluationTimer: id,
      });

      this.$store.dispatch(
        "log",
        "Self evaluation interval started"
      );      
    },
    startGameTimeout() {
      const id = setInterval(async () => {
        this.gameRobot();
      }, this.timeOut);

      this.$store.commit({
        type: "setGameTimer",
        gameTimer: id,
      });

      this.$store.dispatch(
        "log",
        "Game interval started"
      );      
    },
    startCommentTimeout() {
      const id = setInterval(async () => {
        this.commentRobot();
      }, 15000);

      this.$store.commit({
        type: "setCommentTimer",
        commentTimer: id,
      });       

      this.$store.dispatch(
        "log",
        "Comment interval started"
      );
    },
    startRPSTimeout() {
      const id = setInterval(async () => {
        this.rpsGameRobot();
      }, this.timeOut);

      this.$store.commit({
        type: "setRPSTimer",
        rpsTimer: id,
      });

      this.$store.dispatch(
        "log",
        "RPS interval started"
      );      
    },
    startVotingTimeout() {
      const id = setInterval(async () => {
        this.votingRobot();
      }, 500);

      this.$store.commit({
        type: "setVotingTimer",
        votingTimer: id,
      });

      this.$store.dispatch(
        "log",
        "Voting interval started"
      );      
    },
    clearIntervals() {
      if (this.$store.state.main.gameTimer) {
        clearInterval(this.$store.state.main.gameTimer);

        this.$store.commit({
          type: "setGameTimer",
          gameTimer: null,
        });

        this.$store.dispatch(
          "log",
          "Game interval cleared"
        );
      }

      if (this.$store.state.main.selfEvaluationTimer) {
        clearInterval(this.$store.state.main.selfEvaluationTimer);

        this.$store.commit({
          type: "setSelfEvaluationTimer",
          selfEvaluationTimer: null,
        });

        this.$store.dispatch(
          "log",
          "Self evaluation interval cleared"
        );        
      }

      if (this.$store.state.main.commentTimer) {
        clearInterval(this.$store.state.main.commentTimer);

        this.$store.commit({
          type: "setCommentTimer",
          commentTimer: null,
        });

        this.$store.dispatch(
          "log",
          "Comment interval cleared"
        );        
      }

      if (this.$store.state.main.rpsTimer) {
        clearInterval(this.$store.state.main.rpsTimer);

        this.$store.commit({
          type: "setRPSTimer",
          gameTimer: null,
        });

        this.$store.dispatch(
          "log",
          "RPS interval cleared"
        );
      }
    },
    async selfEvaluationRobot() {
      if (this.$store.state.main.reportingOpen) {
        return;
      }

      if (this.selfEvaluationStop) {
        if (this.selfEvaluationStop < this.selfEvaluationStart && Date.now() - this.selfEvaluationStop < 2000) {
          // previous robot not finished yet or network hickup
          return;
        }
      } else {
        this.selfEvaluationStop = Date.now();
      }

      const robots = this.$store.getters.getRobotPlayersWithoutSelfEvaluation;      

      this.selfEvaluationStart = Date.now();

      if (!robots.length) {
        // no more robot players
        return;
      }

      const robot = sample(robots);

      this.$store.dispatch(
        "log",
        "Generating self evaluations for robot " + robot.id
      );

      const priorities = [];
      const cases = [];

      for (let i = 0; i < this.$store.getters.getNumberOfCases; i++) {
        priorities.push(i + 1);
        cases.push(this.$store.getters.getCasesInCurrentLocale[i].case);
      }

      shuffleInplace(priorities);

      const selfEvaluations = [];

      for (let i = 0; i < this.$store.getters.getNumberOfCases - 1; i++) {

        selfEvaluations.push(createSelfEvaluation(
          robot.id,
          cases[i],
          priorities[i],
          false,
          this.$store.state.main.game.gameCode
        ));
      }

      Promise.all(selfEvaluations).then((a) => {
        createSelfEvaluation(
          robot.id,
          cases[this.$store.getters.getNumberOfCases - 1],
          priorities[this.$store.getters.getNumberOfCases - 1],
          true,
          this.$store.state.main.game.gameCode
        );

        this.selfEvaluationStop = Date.now();        
      });
    },
    async gameRobot() {
      if (this.$store.state.main.reportingOpen) {
        return;
      }

      if (this.gameStop) {
        if (this.gameStop < this.gameStart && Date.now() - this.gameStop < 5000) {
          // previous robot not finished yet or network hickup

          return;
        }
      } else {
        this.gameStop = Date.now();  
      }

      this.gameStart = Date.now();

      const robots = this.$store.getters.getRobotPlayersWithoutNomination;

      if (robots.length) {
        const nominee = sample(this.$store.state.main.allPlayers).id;
        const robot = sample(robots);
        this.$store.dispatch(
          "log",
          "Sending nomination for robot " + robot.id + " nominee " + nominee
        );

        await sendNomination(
          this.$store.state.main.game.id,
          robot.id,
          nominee,
          this.$store.getters.getCurrentCase.case,
          this.$store.state.main.game.gameCode
        ).then(async (resp) => {
          await this.$store.dispatch({
            type: "updateNominations",
            caseId: this.$store.getters.getCurrentCase.case,
          });
        });

        this.gameStop = Date.now();
        return;
      }

      if (!this.$store.state.main.game.enableSurvey) {
        this.gameStop = Date.now();
        return;
      }

      const options = this.$store.getters.getGameCaseOptionsForCase(
        this.$store.getters.getCurrentCase.case
      );

      if (!options || !options[0] || !options[0].show_survey_questions) {
        // Survey not open yet
        this.gameStop = Date.now();
        return;
      }

      const surveyRobots = this.$store.getters.getRobotPlayersWithoutSurvey;

      if (surveyRobots.length) {
        const robot = sample(surveyRobots);

        for (let i = 1; i <= 2; i++) {
          const answer = Math.floor(
            Math.random() * this.$store.state.main.game.surveyScale + 1
          );

          if (i === 1 && this.$store.getters.hasSomePlayerAnsweredSurvey(this.$store.getters.getCurrentCase.case, 1, robot.id)) {
            // This robot only need to answer survey 2
            continue;
          }
          
          this.$store.dispatch(
            "log",
            "Sending survey answer for robot " + robot.id + " case " + this.$store.getters.getCurrentCase.case + " survey number " + i + " answer " + answer
          );

          await sendSurvey(
            this.$store.state.main.game.id,
            robot.id,
            this.$store.getters.getCurrentCase.case,
            i,
            answer,
            this.$store.state.main.game.gameCode
          ).then((resp) => {
          }, reason => {
            // Collision -> Vuex is out of sync?! Do nothing as refresh will be forced
            this.$store.dispatch("log", "Warning: Survey collision");
          });
        }

        await this.$store.dispatch("updateSurveyAnswers");  
      }

      this.gameStop = Date.now();        
    },
    async rpsGameRobot() {
      if (this.$store.state.main.reportingOpen) {
        return;
      }

      if (this.gameStop) {
        if (this.gameStop < this.gameStart && Date.now() - this.gameStop < 5000) {
          // previous robot not finished yet or network hickup

          return;
        }
      } else {
        this.gameStop = Date.now();  
      }

      this.gameStart = Date.now();

      const robots = this.$store.getters.getRobotPlayersWithoutRPSAnswer;

      if (robots.length) {
        const robot = sample(robots);

        const caseNumber = this.$store.getters.getCurrentCaseNumber
        const rpsCase = this.$store.getters.getRPSCaseByCaseNumber(caseNumber);

        const allChoices = this.$store.getters.getRPSCaseChoicesOfRPSCaseInCurrentLocale(
          rpsCase.rpsCase
        );

        const answer = sample(allChoices);

        this.$store.dispatch(
          "log",
          "Sending rps answer for robot " + robot.id + " answer " + answer.rps_case_choice
        );

        await sendRPSAnswer(
          this.$store.state.main.game.id,
          robot.id,
          this.$store.state.main.game.gameCode,
          answer.rps_case,
          answer.rps_case_choice,
        ).then(async (resp) => {
          await this.$store.dispatch({
            type: "updateRPSAnswers"
          });
        });

        this.gameStop = Date.now();
        return;
      }

      this.gameStop = Date.now();
    },
    async commentRobot() {
      if (this.$store.state.main.reportingOpen) {
        return;
      }

      const robots = this.$store.getters.getRobotPlayers;

      if (!robots.length) {
        return;
      }

      if (this.$store.getters.getCommentsByCaseNumber(this.$store.getters.getCurrentCaseNumber).length >= 5) {
        return;
      }

      const robot = sample(robots);

      this.$store.dispatch(
        "log",
        "Sending survey comment by robot " + robot.id
      );

      sendComment(
        this.$store.state.main.game.id,
        robot.id,
        "Lorem ipsum",
        this.$store.getters.getCurrentCase.case,
        this.$store.state.main.game.gameCode
      ).then((resp) => {});      
    },
    async votingRobot() {
      if (!this.$store.state.main.game.actionPlanActivated || this.$store.state.main.game.actionPlanVotingFinished) {
        return;
      }

      const robots = this.$store.getters.getRobotPlayersWithout3ActionPlanVotes;

      if (!robots.length) {
        return;
      }

      const robot = sample(robots);

      const cases = this.$store.getters.getUnvotedCasesByPlayer(robot);

      if (!cases.length) {
        return;
      }

      const aCase = sample(cases)

      this.$store.dispatch(
        "log",
        "Sending vote by robot " + robot.id
      );

      sendActionPlanVote(
        this.$store.state.main.game.id,
        robot.id,
        aCase.case,
        aCase.rpsCase,
        this.$store.state.main.game.gameCode
        );
    }
  },
};
</script>
